import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchLabelsByInvoice = (invoice, {box, partCode, labelType}) => {
  const boxFilterText = box ? `&box=${box}` : '';
  const partCodeFilterText = partCode ? `&partCode=${partCode}` : '';
  const labelTypeFilter = labelType ? `&type=${labelType}` : '';
  return apiActionCreator({
    'endpoint': `/checkProcesses/invoices/${invoice}/labels?${boxFilterText}${partCodeFilterText}${labelTypeFilter}`,
    'authenticated': true,
    'types': [
      ActionTypes.FECTHING_LABELS_BY_INVOICE,
      ActionTypes.FECTHED_LABELS_BY_INVOICE,
      [
        ActionTypes.FECTHED_LABELS_BY_INVOICE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const changeLabelsListPage = (value) => ({
  'type': ActionTypes.CHANGE_LABELS_LIST_PAGE,
  'payload': value,
});

export const changeLabelsListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_LABELS_LIST_PAGE_SIZE,
  'payload': value,
});

export const emptyLabels = () => ({
  'type': ActionTypes.EMPTY_LABELS,
});
